import store from '@/store'

export function LoginGuard (to, from, next) {
  if(!localStorage.getItem('Token')){
    window.$msgBox.alertMessageBox({
      title: '提示',
      content: '请先登录账号',
      btnText: '前往登录',
    }).then(async (data) => {
      //跳转登录页
      next && next({
        path: '/account/login',
        query: {
          redirect: to.fullPath
        }
      })
    }).catch((val) => {}); 
    return false
  }else{
    return true
  }
};


export function userGuard(to, from, next) {
  let accountInfo = store.getters['accountStore/accountInfo'];
  if (accountInfo && accountInfo.dataState == 2) {
    return true
  } else {
    window.$msgBox.alertMessageBox({
      title: "提示",
      content: "您账号的创建应用权限已被冻结，若有疑问请联系官方客服xxxx",
      btnText:'好的',
    })
    .then(async data => {
      next({
        path: router.currentRoute.fullPath
      }) 
    })
    return false
  }
};



export function infoGuard (to, from, next) {
  let accountInfo = store.getters['accountStore/accountInfo'];
  //是否完善资料(dataState:1-未完善 2-已完善 3-冻结 4-待审核 5-未通过)
  if (window.$utils.isEmpty(accountInfo) && accountInfo.dataState != 2) { 
    //跳转完善资料状态页
    next({
      path: '/account/perfect/status'
    }); 
    return false
  }else{
    return true
  }
};